export * from './hr.blot';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/hr/index.ts